import { VisualisationType } from 'store/reducers/visualisations/types';

export const defaultVisualisationWithActiveIncisionId = ['tree', 'pie', 'lineAndBar', 'waterfall', 'bubble'];

export const visualisationTypes: VisualisationType[] = ['tree', 'pie', 'lineAndBar', 'waterfall', 'bubble', 'heatmap', 'table'];
